import {
  PodcastImg,
  ReleaseCard as StyledReleaseCard,
  ReleaseInfo,
  ReleaseButtons,
  ReleaseTitle,
  ReleaseDuration,
  ReleaseBody,
  ReleaseLive,
  ReleaseDate,
  ReleasePlay,
  Dot,
  TitleWrapper,
} from "./styled";
import Typography from "../Typography";
import { useLocation } from "react-router-dom";
import LiveIcon from "../LiveIcon";
import { useEffect, useRef, useState } from "react";
import TrackProgressBar from "../TrackProgressBar";
import PlayAudioButton from "../PlayAudioButton";
import { CircleShadow } from "./CircleShadow";
import { formatDate } from "../../utils/utils";

import {
  pause,
  playMedia,
  setCurrentContent,
} from "../../redux/Slice/playerSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentContent,
  selectCurrentEntity,
  selectIsPlaying,
} from "../../redux/selectors/playerSelector";
import { formatLeftTime } from "../../utils/formatLeftTime";

import { setPlaylistReleases } from "../../redux/Slice/playlistReleasesSlice";
import { AdultIconWithTooltip } from "../AdultIconWithTooltip";
import { LikePodcastBtnWrapper } from "../LikeTrackBtn/LikePodcastBtnWrapper";
import { useMediaQuery } from "../../hooks/useMediaQuery";

// inPodcast - отвечает за отображение карточки выпуска на странице подкаста (только за отображение)

export const ReleaseCard = ({
  release,
  showPodcastInfo,
  releasePodcast,
  showLikeBtn,
  index,
  playlistReleases,
  inPodcast,
  onClickCard,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const targetPath = `/podcasts/${release.podcastLink}`;
  const isPodcastPage = location.pathname === targetPath;
  const currentEntity = useSelector(selectCurrentEntity);
  const currentContent = useSelector(selectCurrentContent);
  const cardRef = useRef(null);

  const [cardWidth, setCardWidth] = useState(0);

  const isMobile = useMediaQuery("(max-width: 500px)");

  useEffect(() => {
    setCardWidth(cardRef.current?.offsetWidth);
  }, [setCardWidth, cardRef, release]);

  useEffect(() => {
    if (currentEntity === "release" && currentContent.id === release.id) {
      dispatch(setCurrentContent(release));
    }
  }, [currentContent?.id, currentEntity, dispatch, release]);

  const isPlaying = useSelector(selectIsPlaying);

  const handlePlayClick = (e) => {
    e.stopPropagation();

    if (currentContent?.id === release.id && isPlaying) {
      dispatch(pause());
      return;
    }

    dispatch(playMedia(release.audioFileLink));
    dispatch(setCurrentContent(release));
    dispatch(
      setPlaylistReleases(playlistReleases.filter((item) => !item.isLive)),
    );
  };

  return (
    <StyledReleaseCard
      ref={cardRef}
      showPodcastInfo={showPodcastInfo}
      onClick={isMobile ? handlePlayClick : () => onClickCard(release)}
      duration={index * 500}
      tabIndex={0}
      isPodcastPage={isPodcastPage}
      id={release.trackLink}
    >
      {showPodcastInfo && (
        <PodcastImg
          src={release?.cover.small || releasePodcast?.cover?.small}
          alt={releasePodcast?.title || release?.title}
        />
      )}
      <ReleaseBody showPodcastInfo={showPodcastInfo}>
        {release.isLive && !showPodcastInfo && (
          <ReleaseLive>
            <LiveIcon />
            <Typography component="span" variant="h4">
              Лайв
            </Typography>
          </ReleaseLive>
        )}

        <ReleaseInfo>
          <TitleWrapper>
            {release.isAdult && <AdultIconWithTooltip />}
            <Typography variant="h4" as={ReleaseTitle}>
              {release.title}
            </Typography>
          </TitleWrapper>
          {inPodcast && (
            <Typography as={ReleaseDuration} color="secondary" component="span">
              <Dot>•</Dot> {formatLeftTime(release.durationInSeconds)}
            </Typography>
          )}
        </ReleaseInfo>

        {inPodcast ? (
          <ReleaseInfo>
            <Typography as={ReleaseDate}>
              {formatDate(release.publishedAt)}
            </Typography>
          </ReleaseInfo>
        ) : (
          <ReleaseInfo>
            <Typography as={ReleaseTitle} component="span">
              {release.podcastTitle}
            </Typography>
            <Typography as={ReleaseDuration} color="secondary" component="span">
              <Dot>•</Dot> {formatLeftTime(release.durationInSeconds)}
            </Typography>
          </ReleaseInfo>
        )}
      </ReleaseBody>
      <ReleaseButtons showLikeBtn={showLikeBtn}>
        <ReleasePlay>
          <PlayAudioButton
            audioFileLink={release.audioFileLink}
            trackOrRelease={release}
            playlistReleases={playlistReleases}
          />
          <CircleShadow releaseId={release.id} circleWidth={cardWidth} />
        </ReleasePlay>
        {showLikeBtn && <LikePodcastBtnWrapper release={release} />}
      </ReleaseButtons>
      <TrackProgressBar trackOrReleaseId={release.id} />
    </StyledReleaseCard>
  );
};
